import { columnHeader } from './column-header.js';
import { expandableRegion } from './expandable-region.js';
import { matchScore } from './match-score.js';
import { modalBox } from './modal-box.js';
import { notification } from './notification.js';
import { pagination } from './pagination.js';
import { tabs } from './tabs.js';
import { chip } from './chip.js';
import { autocomplete } from './autocomplete.js';
export const copy = {
    columnHeader,
    expandableRegion,
    matchScore,
    modalBox,
    notification,
    pagination,
    tabs,
    chip,
    autocomplete,
};
//# sourceMappingURL=index.js.map